<template>
  <form @submit.prevent="save()" class="ui small form">
    <h3 class="ui header">Configurações de Notificações</h3>
    <div class="field">
      <label for="notification-gateway-setting">
        Configurações do Gateway de Envio
      </label>
      <textarea
        v-model="form.notification_gateway"
        id="notification-gateway-setting"
        rows="8"
        cols="80"
      >
      </textarea>
    </div>
    <h4 class="ui dividing header">Boas Vindas</h4>
    <div class="ui message">
      <p>Notificação enviada logo após criar um novo contrato.</p>
    </div>
    <div class="inline field">
      <div class="ui toggle checkbox">
        <input
          type="checkbox"
          v-model="form.welcome_notification_enable"
          name="birthday-notification-enable-setting"
        />
        <label>Ativo?</label>
      </div>
    </div>
    <div class="fields">
      <div class="twelve wide field">
        <label for="welcome-notification-text-setting"> Mensagem </label>
        <textarea
          v-model="form.welcome_notification_text"
          id="welcome-notification-text-setting"
          rows="8"
          cols="80"
        >
        </textarea>
        <div class="text-right">{{ textLength(form.welcome_notification_text) }}</div>
      </div>
      <div class="four wide field">
        <label for="">Opções</label>
        <div>[nome_do_titular]</div>
      </div>
    </div>
    <h4 class="ui dividing header">Parcela atrasada</h4>
    <div class="ui message">
      <p>Notificação enviada quando contrato atrasado entre 5 e 15 dias.</p>
    </div>
    <div class="inline field">
      <div class="ui toggle checkbox">
        <input
          type="checkbox"
          v-model="form.late_notification_enable"
          name="late-notification-enable-setting"
        />
        <label>Ativo?</label>
      </div>
    </div>
    <div class="fields">
      <div class="twelve wide field">
        <label for="late-notification-text-setting"> Mensagem </label>
        <textarea
          v-model="form.late_notification_text"
          id="late-notification-text-setting"
          rows="8"
          cols="80"
        >
        </textarea>
        <div class="text-right">{{ textLength(form.late_notification_text) }}</div>
      </div>
      <div class="four wide field">
        <label for="">Opções</label>
        <div>[nome_do_titular]</div>
        <div>[competencia_da_parcela]</div>
      </div>
    </div>
    <h4 class="ui dividing header">Inadimplente</h4>
    <div class="ui message">
      <p>Notificação enviada quando contrato atrasado há 30 dias ou mais.</p>
    </div>
    <div class="inline field">
      <div class="ui toggle checkbox">
        <input
          type="checkbox"
          v-model="form.overdue_notification_enable"
          name="overdue-notification-enable-setting"
        />
        <label>Ativo?</label>
      </div>
    </div>
    <div class="fields">
      <div class="twelve wide field">
        <label for="overdue-notification-text-setting"> Mensagem </label>
        <textarea
          v-model="form.overdue_notification_text"
          id="overdue-notification-text-setting"
          rows="8"
          cols="80"
        >
        </textarea>
        <div class="text-right">{{ textLength(form.overdue_notification_text) }}</div>
      </div>
      <div class="four wide field">
        <label for="">Opções</label>
        <div>[nome_do_titular]</div>
        <div>[competencia_da_parcela]</div>
        <div>[valor_da_parcela]</div>
        <div>[data_de_vencimento]</div>
      </div>
    </div>
    <div class="field">
      <label for="overdue-notification-exclude-plans">
        Ignorar planos ao enviar notificação.
      </label>
      <select
        id="overdue-notification-exclude-plans"
        class="ui fluid search dropdown"
        v-model="form.overdue_notification_exclude_plans"
        multiple=""
      >
        <option v-for="(plan, index) in plans" :key="index" :value="plan.id">
          {{ plan.description }} - {{ plan.id }}
        </option>
      </select>
    </div>
    <h4 class="ui dividing header">Renovação de contrato</h4>
    <div class="ui message">
      <p>Notificação enviada na renovação anual do contrato.</p>
    </div>
    <div class="inline field">
      <div class="ui toggle checkbox">
        <input
          type="checkbox"
          v-model="form.renewed_notification_enable"
          name="renewed-notification-enable-setting"
        />
        <label>Ativo?</label>
      </div>
    </div>
    <div class="fields">
      <div class="twelve wide field">
        <label for="renewed-notification-text-setting"> Mensagem </label>
        <textarea
          v-model="form.renewed_notification_text"
          id="overdue-notification-text-setting"
          rows="8"
          cols="80"
        >
        </textarea>
        <div class="text-right">{{ textLength(form.renewed_notification_text) }}</div>
      </div>
      <div class="four wide field">
        <label for="">Opções</label>
        <div>[nome_do_titular]</div>
        <div>[competencia_da_parcela]</div>
        <div>[valor_da_parcela]</div>
        <div>[data_de_vencimento]</div>
      </div>
    </div>
    <h4 class="ui dividing header">À vencer</h4>
    <div class="ui message">
      <p>Notificação enviada 5 dias antes do vencimento da parcela.</p>
    </div>
    <div class="inline field">
      <div class="ui toggle checkbox">
        <input
          type="checkbox"
          v-model="form.to_expire_notification_enable"
          name="to-expire-notification-enable-setting"
        />
        <label>Ativo?</label>
      </div>
    </div>
    <div class="fields">
      <div class="twelve wide field">
        <label for="to-expire-notification-text-setting"> Mensagem </label>
        <textarea
          v-model="form.to_expire_notification_text"
          id="to-expire-notification-text-setting"
          rows="8"
          cols="80"
        >
        </textarea>
        <div class="text-right">{{ textLength(form.to_expire_notification_text) }}</div>
      </div>
      <div class="four wide field">
        <label for="">Opções</label>
        <div>[nome_do_titular]</div>
        <div>[competencia_da_parcela]</div>
        <div>[valor_da_parcela]</div>
        <div>[data_de_vencimento]</div>
      </div>
    </div>
    <h4 class="ui dividing header">Notificação de Aniversário</h4>
    <div class="ui message">
      <p>
        Notificação enviada no dia do aniversário do tilular de um contrato
        ativo.
      </p>
    </div>
    <div class="inline field">
      <div class="ui toggle checkbox">
        <input
          type="checkbox"
          v-model="form.birthday_notification_enable"
          name="birthday-notification-enable-setting"
        />
        <label>Ativo?</label>
      </div>
    </div>
    <div class="fields">
      <div class="twelve wide field">
        <label for="birthday-notification-text-setting"> Mensagem </label>
        <textarea
          v-model="form.birthday_notification_text"
          id="birthday-notification-text-setting"
          rows="8"
          cols="80"
        >
        </textarea>
        <div class="text-right">{{ textLength(form.birthday_notification_text) }}</div>
      </div>
      <div class="four wide field">
        <label for="">Opções</label>
        <div>[nome_do_titular]</div>
      </div>
    </div>
  </form>
</template>
<script>
import SettingsMixins from '@/mixins/settings_mixins';
import Api from '@/resources/Api';
export default {
  mixins: [SettingsMixins],
  data() {
    return {
      plans: [],
      form: {
        notification_gateway: null,
        birthday_notification_enable: false,
        birthday_notification_text: null,
        welcome_notification_enable: false,
        welcome_notification_text: null,
        late_notification_enable: false,
        late_notification_text: null,
        overdue_notification_enable: false,
        overdue_notification_text: null,
        overdue_notification_exclude_plans: [],
        to_expire_notification_enable: false,
        to_expire_notification_text: null,
        renewed_notification_enable: false,
        renewed_notification_text: null
      }
    };
  },

  mounted() {
    this.getData();
  },

  methods: {
    textLength(text){
      return text ? `${text.length} caracteres` : ''
    },
    async getData() {
      const plansQuery = {
        q: {
          enable_eq: true,
          s: ['id asc']
        }
      };
      await this.$sleep(2000);

      const plansResponse = await Api.plans.search(plansQuery);
      this.plans = _.clone(plansResponse.data.plans);

      $('#overdue-notification-exclude-plans').dropdown();
      this.form.overdue_notification_exclude_plans.forEach(plan => {
        $('#overdue-notification-exclude-plans').dropdown('set selected', plan);
      });
    }
  }
};
</script>
